<div class="app-container">
  <header class="app-header" *ngIf="currentUser && !isShareRoute">
    <div class="header-top">
      <h1>Taptimize MK2</h1>
      <p class="header-tagline">SEO optimization and content analysis platform</p>
    </div>
    <div class="global-domain-bar" *ngIf="availableDomains.length > 0">
      <label for="global-domain-select" class="global-domain-label">Active domain</label>
      <select
        id="global-domain-select"
        class="global-domain-select"
        [ngModel]="selectedDomain"
        (ngModelChange)="onDomainChange($event)"
      >
        <option *ngFor="let domain of availableDomains" [value]="domain">{{ domain }}</option>
      </select>

      <div class="domain-settings">
        <button
          type="button"
          class="btn-domain-settings"
          (click)="toggleCompetitorMenu()"
          [attr.aria-expanded]="isCompetitorMenuOpen"
          aria-controls="domain-settings-panel"
          [disabled]="!selectedDomain"
        >
          <span class="domain-settings-icon" aria-hidden="true">&#9881;</span>
          <span>Settings</span>
        </button>

        <div
          id="domain-settings-panel"
          class="domain-settings-panel"
          *ngIf="isCompetitorMenuOpen"
        >
          <p class="domain-settings-title">{{ selectedDomain }}</p>
          <p class="domain-settings-helper">Competitors are saved per active domain.</p>

          <form class="competitor-add-row" (ngSubmit)="addCompetitor()">
            <input
              type="text"
              class="competitor-input"
              [(ngModel)]="newCompetitorInput"
              name="competitorDomain"
              placeholder="Add domain (example.com)"
              [disabled]="isSavingCompetitor"
            />
            <button
              type="submit"
              class="btn-competitor-add"
              [disabled]="isSavingCompetitor"
            >
              Add
            </button>
          </form>

          <p class="competitor-status" *ngIf="isLoadingCompareSettings">Loading competitors...</p>
          <p class="competitor-status competitor-error" *ngIf="compareError">{{ compareError }}</p>
          <p class="competitor-status" *ngIf="!isLoadingCompareSettings && !compareError && markedCompetitors.length === 0">
            Add your first competitor for this domain.
          </p>

          <ul
            class="competitor-list"
            *ngIf="!isLoadingCompareSettings && markedCompetitors.length > 0"
          >
            <li *ngFor="let domain of markedCompetitors" class="competitor-list-item">
              <span class="competitor-domain">{{ domain }}</span>
              <div class="competitor-actions">
                <button
                  type="button"
                  class="btn-competitor-compare"
                  (click)="toggleCompareCompetitor(domain)"
                  [disabled]="isSavingCompetitor || isSavingCompareSelection"
                >
                  {{ isComparedDomain(domain) ? 'Comparing' : 'Compare' }}
                </button>
                <button
                  type="button"
                  class="btn-competitor-remove"
                  (click)="removeCompetitor(domain)"
                  [disabled]="isSavingCompetitor || isSavingCompareSelection"
                >
                  Remove
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <span class="domain-competitor-summary">
        {{ isLoadingCompareSettings ? 'Loading competitors...' : competitorSummaryText }}
      </span>
      <span class="domain-compare-summary" *ngIf="selectedCompareDomain">
        Comparing: {{ selectedCompareDomain }}
      </span>
    </div>
    <nav class="nav-bar">
      <div class="nav-links">
        <!-- Core navigation (always visible) -->
        <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Dashboard</a>
        <a routerLink="/page-comparison" routerLinkActive="active">Compare</a>
        <a routerLink="/inventory" routerLinkActive="active">Inventory</a>

        <!-- Experimental navigation (feature-flagged) -->
        <a *ngIf="featureFlags.isEnabled('setup')" routerLink="/setup" routerLinkActive="active">Setup</a>
        <a *ngIf="featureFlags.isEnabled('domainTopics') || featureFlags.isUserView()" routerLink="/domain-topics" routerLinkActive="active">Domain Topics</a>
        <a *ngIf="featureFlags.isEnabled('crawlManagement')" routerLink="/crawl-management" routerLinkActive="active">Crawl Management</a>
        <a *ngIf="featureFlags.isEnabled('keywordResearch')" routerLink="/keyword-research-test" routerLinkActive="active">Keyword Research</a>
        <a *ngIf="featureFlags.isEnabled('competitorFinder')" routerLink="/competitor-finder" routerLinkActive="active">Competitor Finder</a>
        <ng-container *ngIf="featureFlags.isEnabled('topicShare')">
          <a routerLink="/topic-share" routerLinkActive="active">Topic Share</a>
          <a routerLink="/topic-share-2" routerLinkActive="active">Topic Share 2</a>
          <a routerLink="/topic-share-3" routerLinkActive="active">Topic Share 3</a>
        </ng-container>
      </div>

      <div class="nav-actions">
        <span class="nav-welcome">Welcome, {{ currentUser.name }}</span>
        <button (click)="logout()" class="btn-logout">Logout</button>
      </div>
    </nav>
  </header>

  <!-- Dev/User View toggle (non-production only) -->
  <div class="dev-view-toggle" *ngIf="!featureFlags.isProduction() && currentUser && !isShareRoute">
    <button (click)="toggleDevUserView()" type="button" class="dev-toggle-btn">
      {{ featureFlags.isUserView() ? '👤 User View' : '🛠️ Dev View' }}
    </button>
  </div>

  <main>
    <router-outlet></router-outlet>
  </main>
  <app-global-notification-stack></app-global-notification-stack>
</div>


